export default __webpack_public_path__ + "static/media/logo.5adc4b3b.svg";